import React from 'react';

import { Box } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

export const FolderCardSkeleton: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      border={`1px solid ${theme.palette.divider}`}
      borderRadius={12}
      padding={2}
      minHeight={140}
      bgcolor={theme.palette.background.paper}
    >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box display="flex" alignItems="flex-start" gridGap={12} flex={1} minWidth={0}>
          <Skeleton
            variant="rect"
            width={42}
            height={34}
            style={{ borderRadius: 8, backgroundColor: theme.palette.action.hover }}
          />
          <Box flex={1} minWidth={0}>
            <Skeleton variant="text" width="70%" style={{ backgroundColor: theme.palette.action.hover }} />
            <Skeleton variant="text" width="45%" style={{ backgroundColor: theme.palette.action.hover }} />
          </Box>
        </Box>
        <Skeleton
          variant="rect"
          width={32}
          height={32}
          style={{ borderRadius: 8, backgroundColor: theme.palette.action.hover }}
        />
      </Box>

      <Box marginTop={2}>
        <Skeleton variant="text" width={88} style={{ backgroundColor: theme.palette.action.hover }} />
      </Box>
    </Box>
  );
};
